import { render, staticRenderFns } from "./firstPage.vue?vue&type=template&id=661dec5e&scoped=true"
import script from "./firstPage.vue?vue&type=script&lang=js"
export * from "./firstPage.vue?vue&type=script&lang=js"
import style0 from "./firstPage.vue?vue&type=style&index=0&id=661dec5e&prod&scoped=true&lang=css"
import style1 from "./firstPage.vue?vue&type=style&index=1&id=661dec5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661dec5e",
  null
  
)

export default component.exports